import { render, staticRenderFns } from "./article_simple_page.vue?vue&type=template&id=ee48347a&scoped=true"
import script from "./article_simple_page.vue?vue&type=script&lang=js"
export * from "./article_simple_page.vue?vue&type=script&lang=js"
import style0 from "./article_simple_page.vue?vue&type=style&index=0&id=ee48347a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee48347a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee48347a')) {
      api.createRecord('ee48347a', component.options)
    } else {
      api.reload('ee48347a', component.options)
    }
    module.hot.accept("./article_simple_page.vue?vue&type=template&id=ee48347a&scoped=true", function () {
      api.rerender('ee48347a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/article_simple_page.vue"
export default component.exports